import InventoryDevice from 'features/Inventories/interfaces/InventoryDevice';
import {FilterParams} from 'features/Inventories/reducer/InventoryReducer';

export default function getUniqueInventoryValues(inventoryData: InventoryDevice[]): FilterParams {
  const uniqueValues = {
    // GEO filter order is prefixed
    geo: new Set<string>(['NA', 'EMEA', 'GC', 'APLA']),
    brand: new Set<string>([]),
    siteType: new Set<string>([]),
    storeConcept: new Set<string>([]),
    siteStatus: new Set<string>([]),
    deviceType: new Set<string>([]),
    nvsnso: new Set<string>([]),
  };

  inventoryData?.forEach(device => {
    // As device data can come in a different order we skip it to avoid changes in the prefixed order
    // uniqueValues.geo.add(device.geo);
    uniqueValues.brand.add(device.brand);
    uniqueValues.siteType.add(device.siteType);
    uniqueValues.storeConcept.add(device.storeConcept);
    uniqueValues.siteStatus.add(device.siteStatus);
    uniqueValues.deviceType.add(device.deviceType);
    if (device.nvsnso !== undefined) {
      uniqueValues.nvsnso.add(device.nvsnso);
    }
  });

  for (const [key, value] of Object.entries(uniqueValues)) {
    value.delete('');
  }

  return {
    geo: Array.from(uniqueValues.geo),
    brand: Array.from(uniqueValues.brand),
    siteType: Array.from(uniqueValues.siteType),
    storeConcept: Array.from(uniqueValues.storeConcept).sort(),
    siteStatus: Array.from(uniqueValues.siteStatus),
    deviceType: Array.from(uniqueValues.deviceType),
    nvsnso: ['NVS', 'NSO'],
  };
}
